// extracted by mini-css-extract-plugin
export var pillWrapper = "_xk-0";
export var showOverflow = "_xk-1";